module.exports = __webpack_public_path__ + "img/main-logo.8e509849.png";